import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

import { cn } from "../../shared/utils";

import {
  getPhysicians,
  getUser,
  locationsList,
  specialityList,
} from "../../lib/api";

import { MoreIcon, SearchIcon } from "../../shared/svgIcon";
import { useQuery } from "@tanstack/react-query";
import { useStore } from "../../store";

const DoctorList = (props) => {
  let navigate = useNavigate();
  const setSelectedAppointment = useStore((state) => state.setAppointment);

  const [selectedLocation, setSelectedLocation] = useState("");
  const [searchDoctor, setSearchDoctor] = useState("");
  const [specialities, setSpecialities] = useState([]);
  const [locations, setLocations] = useState([]);

  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const setSelectedSpecialties = useStore(
    (state) => state.setSelectedSpecialties
  );
  const selectedSpecialties = useStore((state) => state.selectedSpecialties);
  // console.log(selectedSpecialties,'selectedSpecialties')
  const {
    data: physiciansList,
    refetch: searchQueryRefetch,
    isLoading,
  } = useQuery({
    queryKey: ["drList", selectedLocation, selectedSpecialties],
    queryFn: () =>
      getPhysicians({
        location: selectedLocation || "",
        available: true,
        specialities: selectedSpecialties?.map((e) => e.id)?.join(",") || "" ,
        // "role_id": "6743852668059afd2478374h",
        page: 1,
        limit: 20,
        name: searchDoctor || "",
        // "organization_id": "6843852668059afd247837355", # optional
        // "specialities": "6543852668059afd2478381e", "6843852668059afd247837355"
      }),
    enabled: locations?.length > 0 && specialities?.length > 0,
  });
  const doctorList = physiciansList?.data?.result || [];

  const handleSpecialtyClick = (specialty) => {
    // setSelectedSpecialty(specialty);
    // Check if the clicked speciality is already selected
    const isSelected = selectedSpecialties?.some(
      (selected) => selected.id === specialty.id
    );

    // If selected, remove it; otherwise, add it
    const updatedSpecialties = isSelected
      ? selectedSpecialties?.filter((selected) => selected.id !== specialty.id)
      : [...selectedSpecialties, specialty];

    // Update the state or perform any other necessary actions
    setSelectedSpecialties(updatedSpecialties);

    sessionStorage.setItem("selectedSpecialties", JSON.stringify(specialty));
  };
  const handleDoctorClick = (val) => {
    setSelectedDoctor(val);

    sessionStorage.setItem("selectedDoctor", JSON.stringify(val));
  };
  const gotoNext = () => {
    if (selectedDoctor?.id) {
      setSelectedAppointment({
        user_id: selectedDoctor?.id,
      });
      navigate(`/doctor/${selectedDoctor?.id}`);
    }
  };
  useEffect(() => {
    // getDrList();

    getSpecialty();
    getLocation();
  }, []);

  const colors =['green-200','red-200','blue-200','orange-200','yellow-100']

  const getSpecialty = async () => {
    if (sessionStorage.getItem("specialities")) {
      const specialities = JSON.parse(sessionStorage.getItem("specialities"));
      setSpecialities(specialities);
      // setSelectedSpecialties([]);
      if (selectedSpecialties?.length == 0) {
        // const selectedSpec = specialities[0];
        // setSelectedSpecialties([selectedSpec]);
      }
      return;
    }
    const res = await specialityList();
    const specialities = res?.data?.result;
    if (!specialities) {
      setSpecialities([]);
    } else {
      setSpecialities(specialities);
      sessionStorage.setItem("specialities", JSON.stringify(specialities));
      setSelectedSpecialties([]);
      if (selectedSpecialties?.length == 0) {
        // const selectedSpec = specialities[0];
        // setSelectedSpecialties([selectedSpec]);
      }
    }
  };
  const getLocation = async () => {
    if (sessionStorage.getItem("locations")) {
      const locations = JSON.parse(sessionStorage.getItem("locations"));
      setLocations(locations);
      // const selectedLocation = locations[0];
      // setSelectedLocation(selectedLocation);
      return;
    }
    const res = await locationsList();
    const locations = res?.data?.result;
    if (!locations) {
      setLocations([]);
    } else {
      setLocations(locations);
      sessionStorage.setItem("locations", JSON.stringify(locations));
      // const selectedLocation = locations[0];
      // setSelectedLocation(selectedLocation);
    }
  };

  const handleLocationChange = async (event) => {
    const location = event.target.value;
    setSelectedLocation(location);
  };

  // Debounce function to delay the API call
  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedSearch = debounce((query) => {
    // Call the query function with the latest search term
    searchQueryRefetch();
  }, 2000); // Adjust the debounce delay as needed

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchDoctor(value);
    debouncedSearch(value);
  };

  return (
    <div className="bg-white min-sh-screen">
      <>
        {" "}
        <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
          <div>
            <Link className="flex" to="/appointment">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-base">Find your doctor</h4>
              </div>
            </Link>
          </div>

          {/* <button
            onClick={handleSubmit}
            className={cn(
              "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
              "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
              "h-9 px-4 py-2"
            )}
          >
            <span className="mr-1 text-lg leading-none">+</span>
            Add Doctor
          </button> */}
        </div>
        <div className=" flex-1 overflow-scroll hideScroll  text-gray-500  flex flex-col pt-12 px-4 pb-16">
          <div className="mt-4 relative">
            <SearchIcon className="absolute left-2 top-5 h-4 w-4 text-muted-foreground" />

            <input
              className="w-full  pl-8 h-14 bg-neutral-100 rounded-[18px] border"
              type="text"
              placeholder="Search doctor"
              value={searchDoctor}
              onChange={handleSearchChange}
            />
          </div>

          <h2 className="text-lg font-semibold mt-5 mb-5 text-[#32365C]">
            Doctors specialties
          </h2>
          <div className="flex items-center justify-between  mb-8 max-w-md">
            {specialities?.slice(0, 3).map((speciality, index) => (
              <div
                key={index}
                className={`flex flex-col cursor-pointer`}
                onClick={() => handleSpecialtyClick(speciality)}
              >
                <div
                  className={`relative flex flex-col items-center justify-center py-4  px-4 w-20 h-20  rounded-[18px] border ${
                    selectedSpecialties?.some(
                      (selected) => selected.id === speciality.id
                    )
                      ? "border-blue-700"
                      : ""
                  } bg-${colors[index % colors.length]}`}
                >
                  <div
                    className={` ${
                      selectedSpecialties?.some(
                        (selected) => selected.id === speciality.id
                      )
                        ? " round"
                        : ""
                    }`}
                  ></div>
                  <img
                    className="w-8 h-8"
                    src={speciality.icon_url}
                    alt={speciality.name}
                  />
                </div>
                <p className="text-center text-slate-700 text-sm font-normal ">
                  {speciality.name}
                </p>
              </div>
            ))}
            <div
              className="flex flex-col"
              onClick={() => navigate("/specialties")}
            >
              <div className="flex flex-col items-center justify-center py-4  px-4 bg-indigo-200 rounded-[18px] border w-20 h-20">
                <MoreIcon width="32px" height="32px" />
              </div>
              <p className="text-center text-slate-700 text-sm font-normal ">
                More
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row sm:gap-4">
            <div className="flex flex-col  w-full sm:w-1/3 ">
              <label
                htmlFor="location"
                className="block mb-5 text-lg font-medium text-[#32365C]  mr-2"
              >
                Select location
              </label>
              <select
                id="location"
                className={cn(
                  "flex   h-14 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm  placeholder:text-muted-foreground focus:outline-none  disabled:cursor-not-allowed disabled:opacity-50",
                  "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg "
                )}
                value={selectedLocation}
                onChange={handleLocationChange}
              >
                <option value="">Select Location</option>
                {locations.map((location, index) => (
                  <option key={index} value={location} className="">
                    {location}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {doctorList.length > 0 && !isLoading && (
            <div className="mb-4 mt-8">
              <label className="text-lg font-semibold text-[#32365C] mb-5 block">
                Select a physician
              </label>

              <div className=" gap-3 md:gap-3 flex-wrap flex-1  sm:justify-normal grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                {doctorList.map((e, index) => (
                  <div
                  className={`flex flex-1 items-center p-4 h-[100px] bg-[#F5F5F5] text-[#32365C] rounded-[18px] border shadow cursor-pointer ${
                    e.id === selectedDoctor?.id ? "border-blue-700 bg-primary text-white" : ""
                  }`}
                    key={index}
                    onClick={() => {
                      // props.handleDrSelect(e);
                      handleDoctorClick(e);
                    }}
                  >

                      <div className="w-[72px] h-[72px] bg-[#D9D9D9] rounded-[24px] overflow-hidden">
                        {e.profile.avatar_url ? (
                          <img
                            className="w-full h-full object-cover"
                            src={e.profile.avatar_url}
                            alt={e.username}
                          />
                        ) : (
                          <img
                            className="w-full h-full object-cover"
                            src={"../../../images/user.svg"}
                            alt={e.username}
                          />
                        )}
                      </div>
                      <div className="ml-4">
                        <p className=" text-lg font-medium">
                          {e.name_prefix} {e.profile.first_name}{" "}
                          {e.profile.middle_name} {e.profile.last_name}
                        </p>
                        <div className="flex text-sm ">
                          {e.specialities &&
                            e.specialities.map((specialities, index) => (
                              <div key={index}>
                                <span
                                  
                                  className="text[#5C5D66] text-base font-normal"
                                >
                                  {specialities.name}
                                </span>{" "}
                                {index < e.specialities.length - 1 && (
                                  <span className="pr-1">,</span>
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    
                  </div>
                ))}
              </div>
            </div>
          )}
          {doctorList.length == 0 && !isLoading && (
            <h1 className="mt-4">No Doctors found</h1>
          )}
          {isLoading && (
            <div className="mt-3 gap-3 md:gap-3 flex-wrap flex-1  sm:justify-normal grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
              {" "}
              <div className="animate-pulse flex flex-row cursor-pointer p-4  w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                <div className=" w-[72px] h-[72px] rounded-full  bg-slate-200"></div>
                <div className="w-full">
                  <div className="m-2 w-full  bg-slate-200 h-4"></div>
                  <div className="m-2  w-full  bg-slate-200 h-2"></div>
                </div>
              </div>
              <div className="animate-pulse flex flex-row cursor-pointer p-4  w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                <div className=" w-[72px] h-[72px] rounded-full  bg-slate-200"></div>
                <div className="w-full">
                  <div className="m-2 w-full  bg-slate-200 h-4"></div>
                  <div className="m-2  w-full  bg-slate-200 h-2"></div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          className="bg-white h-16 fixed bottom-0 w-full flex justify-center"
          onClick={gotoNext}
        >
          <button className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold">
            Book Appointment
          </button>
        </div>
      </>
    </div>
  );
};

export default DoctorList;
